import { useModals } from 'almanac-ui/Modal'
import { InviteTeamModal } from './InviteTeamModal'

export function useOpenInviteModal({ newStack = false }: { newStack?: boolean } = {}) {
  const { openModal } = useModals()

  return () => {
    openModal(InviteTeamModal, {}, { newStack })
  }
}
